import { render } from "./index.vue?vue&type=template&id=7b8edab4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7b8edab4&lang=scss&scoped=true"

import exportComponent from "D:\\work\\lcyhqqxx\\new-student\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8edab4"]])

export default __exports__